var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.params.value)?_c('div',[_vm._v(_vm._s(_vm.params.data.userData.firstName)+" "+_vm._s(_vm.params.data.userData.lastName))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }